(function() {
    'use strict';

    angular.module('stats')
        .controller('OverallStatsController', OverallStatsController);

    OverallStatsController.$inject = ['$state', 'clientStatsDataSrvc', 'dateFormatConst', 'momentSrvc', 'datatableDefaultPageSizeValueConst', 'checkSearchSrvc', 'filterQuerySrvc'];

    function OverallStatsController($state, clientStatsDataSrvc, dateFormatConst, momentSrvc, datatableDefaultPageSizeValueConst, checkSearchSrvc, filterQuerySrvc) {
        var self = this;
        var initialStat = {
            noWeeks: null,
            noMonths: null,
            noYears: null,
            isDefault: false
        }
        var firstStat = Object.assign({}, initialStat);
        firstStat.isDefault = true
        self.stats = [firstStat,]
        self.noComparative = 0;

        self.addComparativeWeeks = addComparativeWeeks;
        self.addComparativeMonths = addComparativeMonths;
        self.addComparativeYears = addComparativeYears;


        function addComparativeWeeks() {
            if (self.noComparative > 0) {
                var stat = Object.assign({}, initialStat);
                stat.noWeeks = self.noComparative;
                self.stats.push(stat);
            }
        }
        function addComparativeMonths() {
            if (self.noComparative > 0) {
                var stat = Object.assign({}, initialStat);
                stat.noMonths = self.noComparative;
                self.stats.push(stat);
            }
        }
        function addComparativeYears() {
            if (self.noComparative > 0) {
                var stat = Object.assign({}, initialStat);
                stat.noYears = self.noComparative;
                self.stats.push(stat);
            }
        }
    }
})();
